import { AfterViewInit, Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Entity } from '@app/shared/models/models.interface';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseViewComponent } from '../base-view/base-view.component';

@Component({
  selector: 'vfs-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListViewComponent<T extends Entity, S = any> extends BaseViewComponent<T, S> implements AfterViewInit {
  @Input() listItemTemplate: TemplateRef<any>;
  @Input() headerButtonRoute: Router;
  @Input() headerButtonRouteParams: any;
  @Input() routeText: string;

  /**
   * After view
   */
  ngAfterViewInit() {
    merge(this.paginator.page)
      .pipe(tap(() => this.loadPage()))
      .subscribe();
  }

  /**
   * Get the list source
   */
  listSource() {
    if (this.dataSource.getElements()) {
      return this.dataSource.getElements();
    } else {
      return null;
    }
  }
}
